import type { ReactNode } from 'react'
import styled from 'styled-components'
import { Button } from '@/components'

const Wrapper = styled.div<{ border?: boolean; disabled?: boolean }>`
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  border-radius: ${props => props.theme.standardBorderRadius};
  border: ${props =>
    props.border ? `1px solid ${props.theme.colors.gray9}` : 'none'};
  background-color: ${props => props.theme.colors.white};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'inherit')};

  ${props =>
    props.disabled &&
    `
    & * {
      pointer-events: none;
      cursor: not-allowed;
    }
  `}

  & > *:first-child {
    border-right: 1px solid ${props => props.theme.colors.gray9};
    margin-right: 1rem;
    padding-right: 1rem;
  }
  & > *:last-child {
    cursor: pointer;
  }
  ${props => props.theme.media.mobile} {
    width: 100%;
  }
`

export const TextAndAction: React.FC<{
  text: string
  /** Shown beside the text; stays interactive when the row is disabled. */
  info?: ReactNode
  actionText?: string
  border?: boolean
  restrictWidth?: boolean
  disabled?: boolean
  onClick?: () => void
}> = ({ text, info, actionText, border, disabled, onClick }) => {
  return (
    <Wrapper
      border={border}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
    >
      <div className="flex items-center gap-2">
        {text}
        {info}
      </div>
      <Button size="sm" disabled={disabled} onClick={onClick}>
        {actionText ? actionText : '+'}
      </Button>
    </Wrapper>
  )
}
